import { AppRoute, MenuStage, NavigationLinkBase } from '@ebeihilfe/core';
import { Injectable } from '@angular/core';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';

@Injectable()
export class PrivacyNavLink extends NavigationLinkBase {
  public allowedStages = MenuStage.INIT;

  constructor() {
    super('PRIVACY', _('label.privacy'), AppRoute.InfoPrivacy, _('a11y.link.privacy'), 'ABOUT');
  }
}
